// Tab positions on the emissions group page (emissions-overview-group-page.tsx): Emissions first,
// then Tasks (only on an open period), Assumptions (only for admins and analysts) and Notes, so every
// later tab moves when Tasks or Assumptions is hidden. Worked out in one place so the tabs and their
// panels always agree. A hidden tab gets -1.

export interface IGroupPageTabIndexes {
  tasks: number
  emissions: number
  assumptions: number
  notes: number
}

export function getGroupPageTabIndexes({ showTasksTab, showAssumptionsTab }: { showTasksTab: boolean, showAssumptionsTab: boolean }): IGroupPageTabIndexes {
  let next = 0
  const emissions = next++
  const tasks = showTasksTab ? next++ : -1
  const assumptions = showAssumptionsTab ? next++ : -1
  const notes = next++
  return { tasks, emissions, assumptions, notes }
}
